import { Address, AddressValue } from '@multiversx/sdk-core/out';
import { contractAddress } from 'config';
import { useGetAccount, useGetNetworkConfig } from 'hooks';

import { getScController } from './smartContract';

export const useGetTimeToPong = () => {
  const { network } = useGetNetworkConfig();
  const { address } = useGetAccount();

  const getTimeToPong = async () => {
    try {
      const scController = getScController(network);

      const [result] = await scController.query({
        contract: Address.newFromBech32(contractAddress),
        function: 'getTimeToPong',
        arguments: [new AddressValue(new Address(address))]
      });

      const secondsRemaining: number = result?.valueOf()?.toNumber();

      return secondsRemaining;
    } catch (err) {
      console.error('Unable to call getTimeToPong', err);
    }
  };

  return getTimeToPong;
};
